var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPercentageCardBenefitIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.589844,
    width: 40,
    height: 40,
    rx: 12,
    fill: "#E7F0FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5898C17.7 21.5898 19 22.8898 19 24.5898C19 26.2898 17.7 27.5898 16 27.5898C14.3 27.5898 13 26.2898 13 24.5898C13 22.8898 14.3 21.5898 16 21.5898ZM16 25.5898C16.6 25.5898 17 25.1898 17 24.5898C17 23.9898 16.6 23.5898 16 23.5898C15.4 23.5898 15 23.9898 15 24.5898C15 25.1898 15.4 25.5898 16 25.5898Z",
    fill: "#86B4F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19.5898C22.3 19.5898 21 18.2898 21 16.5898C21 14.8898 22.3 13.5898 24 13.5898C25.7 13.5898 27 14.8898 27 16.5898C27 18.2898 25.7 19.5898 24 19.5898ZM24 15.5898C23.4 15.5898 23 15.9898 23 16.5898C23 17.1898 23.4 17.5898 24 17.5898C24.6 17.5898 25 17.1898 25 16.5898C25 15.9898 24.6 15.5898 24 15.5898Z",
    fill: "#86B4F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27.5898H21V25.5898H23.6L13.3 15.2898C12.9 14.8898 12.9 14.2898 13.3 13.8898C13.5 13.6898 13.7 13.5898 14 13.5898C14.3 13.5898 14.5 13.6898 14.7 13.8898L25 24.1898V21.5898H27V26.5898C27 27.1898 26.6 27.5898 26 27.5898Z",
    fill: "#86B4F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageCardBenefitIcon);
export default __webpack_public_path__ + "static/media/percentage-card-benefit-icon.5381893b7d87076d8a58d674f1f8b67b.svg";
export { ForwardRef as ReactComponent };